import {ReactNode} from 'react';
import {PayPalScriptProvider, ReactPayPalScriptOptions} from '@paypal/react-paypal-js';
import {paypalClientId, paypalOptions} from '../config/paypal';

interface PayPalProviderProps {
    children: ReactNode;
    intent?: 'capture' | 'authorize';
}

export const PayPalProvider = ({children, intent}: PayPalProviderProps) => {
    const initialOptions: ReactPayPalScriptOptions = {
        clientId: paypalClientId,
        currency: paypalOptions.currency,
        intent: intent || paypalOptions.intent,
        vault: true,
        'data-client-token': undefined
    };

    return (
        <PayPalScriptProvider options={initialOptions}>
            {children}
        </PayPalScriptProvider>
    );
};
